<div class="filtriWrapper hideDesktop" id="toppage">
  <div class="warn-spedizione mb-1" *ngIf="infoSpedizioni && isScontoValido()">
    <span class="material-symbols-outlined icona"> check_circle </span>
    <div
      *ngIf="!infoSpedizioni.attivoScontoPerc"
      class="content-spedizione"
      [innerHTML]="
        'base.sconto_fisso'
          | translate
            : {
                sconto: infoSpedizioni.scontoEuro | number : '1.2-2',
                from: infoSpedizioni.scontoFrom | number : '1.2-2'
              }
      "
    ></div>
    <div
      *ngIf="infoSpedizioni.attivoScontoPerc"
      class="content-spedizione"
      [innerHTML]="
        'base.sconto_percentuale'
          | translate
            : {
                sconto: infoSpedizioni.scontoPercentuale | number : '1.2-2',
                from: infoSpedizioni.scontoFrom | number : '1.2-2'
              }
      "
    ></div>
  </div>
  <div class="input-wrapper">
    <div
      class="warn-spedizione mb-1"
      *ngIf="infoSpedizioni && infoSpedizioni.isSpedizioneGratis"
    >
      <span class="material-symbols-outlined icona"> local_shipping </span>
      <div
        class="content-spedizione"
        [innerHTML]="
          'base.spedizione'
            | translate
              : { value: infoSpedizioni.spedizioneGratis | number : '1.2-2' }
        "
      ></div>
    </div>
    <div class="flex__select">
      <div class="carrello mb-1" (click)="apriBooking()">
        <span class="material-symbols-outlined icona"> shopping_cart </span>
      </div>
      <mat-form-field appearance="outline">
        <mat-label>{{ "base.filtra_per" | translate }}</mat-label>
        <mat-select
          [(ngModel)]="filtroProdotto"
          name="prodotti"
          (selectionChange)="filtraEmit()"
          [disabled]="vinoSelezionato"
        >
          <mat-option
            *ngFor="let prodotto of prodottiVisibili"
            [value]="prodotto.id"
          >
            {{ prodotto.label_traduzione | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>

<div class="filtriWrapper hideMobile" id="toppage">
  <div class="warn-spedizione mb-1" *ngIf="infoSpedizioni && isScontoValido()">
    <span class="material-symbols-outlined icona"> check_circle </span>
    <div
      *ngIf="!infoSpedizioni.attivoScontoPerc"
      class="content-spedizione"
      [innerHTML]="
        'base.sconto_fisso'
          | translate
            : {
                sconto: infoSpedizioni.scontoEuro | number : '1.2-2',
                from: infoSpedizioni.scontoFrom | number : '1.2-2'
              }
      "
    ></div>
    <div
      *ngIf="infoSpedizioni.attivoScontoPerc"
      class="content-spedizione"
      [innerHTML]="
        'base.sconto_percentuale'
          | translate
            : {
                sconto: infoSpedizioni.scontoPercentuale | number : '1.2-2',
                from: infoSpedizioni.scontoFrom | number : '1.2-2'
              }
      "
    ></div>
  </div>
  <div class="second__block">
    <div class="input-wrapper">
      <mat-form-field appearance="outline">
        <mat-label>{{ "base.filtra_per" | translate }}</mat-label>
        <mat-select
          [(ngModel)]="filtroProdotto"
          name="prodotti"
          (selectionChange)="filtraEmit()"
          [disabled]="vinoSelezionato"
        >
          <mat-option
            *ngFor="let prodotto of prodottiVisibili"
            [value]="prodotto.id"
          >
            {{ prodotto.label_traduzione | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div
      class="warn-spedizione"
      *ngIf="infoSpedizioni && infoSpedizioni.isSpedizioneGratis"
    >
      <span class="material-symbols-outlined icona"> local_shipping </span>
      <div
        class="content-spedizione"
        [innerHTML]="
          'base.spedizione'
            | translate
              : { value: infoSpedizioni.spedizioneGratis | number : '1.2-2' }
        "
      ></div>
    </div>
    <div class="carrello" (click)="apriBooking()">
      <span class="material-symbols-outlined icona"> shopping_cart </span>
    </div>
  </div>
</div>
